var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-group",
      attrs: { "data-testid": `formGroup-${_vm.id}` },
    },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "d-flex esinput__label",
              class: {
                "esinput__label--bold": _vm.boldLabel,
              },
              attrs: { for: _vm.id, "data-testid": `inputLabel-${_vm.id}` },
            },
            [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "input-group-lg position-relative d-flex justify-content-center align-items-center",
        },
        [
          _vm.prependText
            ? _c(
                "div",
                {
                  staticClass: "input-group-prepend",
                  attrs: { "data-testid": `prependText-${_vm.id}` },
                },
                [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(_vm._s(_vm.prependText)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "input",
            _vm._b(
              {
                class: [
                  _vm.inputClass,
                  _vm.plaintext ? "form-control-plaintext" : "form-control",
                  _vm.invalidClass(_vm.validator),
                ],
                attrs: {
                  id: _vm.id,
                  name: _vm.name ? _vm.name : _vm.id,
                  disabled: _vm.plaintext,
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.updateValue,
                  blur: function ($event) {
                    return _vm.$emit("blur", $event)
                  },
                  change: function ($event) {
                    return _vm.validator.$touch()
                  },
                  keyup: function ($event) {
                    return _vm.$emit("keyup", $event)
                  },
                },
              },
              "input",
              _vm.$attrs,
              false
            )
          ),
          _vm._v(" "),
          _vm.appendText
            ? _c(
                "div",
                {
                  staticClass: "input-group-append",
                  attrs: { "data-testid": `appendText-${_vm.id}` },
                },
                [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(_vm._s(_vm.appendText)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("afterInput"),
          _vm._v(" "),
          _vm.$slots.validationText
            ? _c(
                "div",
                { staticClass: "invalid-tooltip" },
                [_vm._t("validationText")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }